import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutThirdFull: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="layout-third-full"><path d="M3.75 3C3.33579 3 3 3.33579 3 3.75V8L21 8V3.75C21 3.33579 20.6642 3 20.25 3H3.75Z" fill="currentColor"/><path d="M3 14.5V9.5L21 9.5V14.5L3 14.5Z" fill="currentColor"/><path d="M3 16V20.25C3 20.6642 3.33579 21 3.75 21H20.25C20.6642 21 21 20.6642 21 20.25V16L3 16Z" fill="currentColor"/></CentralIconBase>;
};

export default IconLayoutThirdFull;
